// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-table {
  width: 100%;
  border-collapse: collapse;
}

.mat-mdc-row,
.mat-mdc-header-row {
  height: 35px;
  white-space: nowrap;
}

.mat-mdc-header-cell {
  font-weight: bold;
  padding: 0 1em 0 1em;
}

.mat-mdc-cell {
  padding: 0 1em 0 1em;
  font-size: 12px;
}

.headerText {
  text-transform: capitalize;
  display: block;
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 20px;
}

.buttonDiv {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  gap: 10px;
  row-gap: 10px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbmZpcm0tY2hhbmdlcy1kaWFsb2cuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxXQUFBO0VBQ0EseUJBQUE7QUFDRjs7QUFFQTs7RUFFRSxZQUFBO0VBQ0EsbUJBQUE7QUFDRjs7QUFFQTtFQUNFLGlCQUFBO0VBQ0Esb0JBQUE7QUFDRjs7QUFFQTtFQUNFLG9CQUFBO0VBQ0EsZUFBQTtBQUNGOztBQUVBO0VBQ0UsMEJBQUE7RUFDQSxjQUFBO0VBQ0EsZUFBQTtFQUNBLGlCQUFBO0VBQ0Esb0JBQUE7QUFDRjs7QUFFQTtFQUNFLGFBQUE7RUFDQSx5QkFBQTtFQUNBLGFBQUE7RUFDQSxTQUFBO0VBQ0EsYUFBQTtBQUNGIiwiZmlsZSI6ImNvbmZpcm0tY2hhbmdlcy1kaWFsb2cuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubWF0LW1kYy10YWJsZSB7XG4gIHdpZHRoOiAxMDAlO1xuICBib3JkZXItY29sbGFwc2U6IGNvbGxhcHNlO1xufVxuXG4ubWF0LW1kYy1yb3csXG4ubWF0LW1kYy1oZWFkZXItcm93IHtcbiAgaGVpZ2h0OiAzNXB4O1xuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xufVxuXG4ubWF0LW1kYy1oZWFkZXItY2VsbCB7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICBwYWRkaW5nOiAwIDFlbSAwIDFlbTtcbn1cblxuLm1hdC1tZGMtY2VsbCB7XG4gIHBhZGRpbmc6IDAgMWVtIDAgMWVtO1xuICBmb250LXNpemU6IDEycHg7XG59XG5cbi5oZWFkZXJUZXh0IHtcbiAgdGV4dC10cmFuc2Zvcm06IGNhcGl0YWxpemU7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBmb250LXNpemU6IDIwcHg7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuICBwYWRkaW5nLWJvdHRvbTogMjBweDtcbn1cblxuLmJ1dHRvbkRpdiB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gIHBhZGRpbmc6IDEwcHg7XG4gIGdhcDogMTBweDtcbiAgcm93LWdhcDogMTBweDtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/components/homepage/confirm-changes-dialog/confirm-changes-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,yBAAA;AACF;;AAEA;;EAEE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,oBAAA;EACA,eAAA;AACF;;AAEA;EACE,0BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;AACF;AACA,wzCAAwzC","sourcesContent":[".mat-mdc-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.mat-mdc-row,\n.mat-mdc-header-row {\n  height: 35px;\n  white-space: nowrap;\n}\n\n.mat-mdc-header-cell {\n  font-weight: bold;\n  padding: 0 1em 0 1em;\n}\n\n.mat-mdc-cell {\n  padding: 0 1em 0 1em;\n  font-size: 12px;\n}\n\n.headerText {\n  text-transform: capitalize;\n  display: block;\n  font-size: 20px;\n  font-weight: bold;\n  padding-bottom: 20px;\n}\n\n.buttonDiv {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px;\n  gap: 10px;\n  row-gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
